export default __webpack_public_path__ + "ca393a2ab71bbd53d692ea4260441286.svg";